import { StyleSheet } from 'react-native';

import cardShadow from '../../Styles/cardShadow';

export default StyleSheet.create({
  cardContainerStyle: theme => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    paddingVertical: 13,
    paddingHorizontal: 16,
    marginHorizontal: 2,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6.2,
    ...cardShadow,
  }),
  arrowIcon: {
    marginRight: 2,
  },
  text: {
    flex: 1,
  },
  topText: {
    fontSize: 18.7,
    lineHeight: 25,
  },
  secondText: {
    fontSize: 16.6,
    lineHeight: 22.9,
  },
  leftIcon: {
    marginLeft: 1,
    marginRight: 16,
  },
});
